module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-800-normal.woff?7eec5e151de35478488273b189850cc8";